export default {
  title: 'Orders Portal',
  form: {
    username: {
      placeholder: 'Gebruikersnaam',
    },
    password: {
      placeholder: 'Wachtwoord',
    },
  },
  buttons: {
    submit: 'Inloggen',
  },
  toasts: {
    auth_token_invalid: 'Opgegeven authenticatietoken is ongeldig, log in met uw inloggegevens',
    credentials_invalid: 'Verkeerde gebruikersnaam of wachtwoord',
  },
};
